import React, {Component} from "react"
import {connect} from 'react-redux';
import Layout from "../../../components/Layout"
import CreateFilters from '../../../components/FilterReports/cockpit';

import "./index.scss"

import {schedule_get_all_filters} from "../../../store/actions/schedule";

import {
    Grid
} from "carbon-components-react";

//import {Undo16} from "@carbon/icons-react";

import leng from "../../../data";


class Create extends Component {
    state = {
        isOppened2: true,
        isOppened3: false,
        isOppenedSubmit: false,
        form: {
            skuisOpened: false,
            skuDetailsisOpenend: false,
            dateStart: "",
            dateEnd: "",
            sku: [],
            brand: [],
            category: [],
            hero: [],
            majorCategory: [],
            abcd: [],
            subCategory: [],
            plcLocal: [],
            chanel: [],
        }
    };

    componentDidMount() {
        //  this.props.fetchData();
    }

    getFilters(data) {
        //console.log(data);
        //alert('A');
        let sku = [];
        let brand = [];
        let category = [];
        let hero = [];
        let majorCategory = [];
        let abcd = [];
        let subCategory = [];
        let plcLocal = [];

        data.forEach(dados => {
            sku.push({id: dados['sku'], text: dados['sku']});
            brand.push({id: dados['marca'], text: dados['marca']});
            category.push({id: dados['category_sku'], text: dados['category_sku']});
            hero.push({id: dados['skherou'], text: dados['hero']});
            majorCategory.push({id: dados['categoria_principal_sku'], text: dados['categoria_principal_sku']});
            abcd.push({id: dados['abcd'], text: dados['abcd']});
            subCategory.push({id: dados['sub_categoria_sku'], text: dados['sub_categoria_sku']});
            plcLocal.push({id: dados['plc_localsku'], text: dados['plc_local']});
        });
        //console.log(sku);
        this.setState({
            sku: sku,
            brand: brand,
            category: category,
            hero: hero,
            majorCategory: majorCategory,
            abcd: abcd,
            subCategory: subCategory,
            plcLocal: plcLocal
        })
    }


    handleChange = e => {
        e.persist();
        const {name, value} = e.target;
        this.setState(prevState => ({
            form: {
                ...prevState.form,
                [name]: value
            }
        }));
    };


    handleChange = e => {
        console.log(e);
        e.preventDefault();
        const {value, name} = e.target;
        this.setState(prevState => ({form: {...prevState.form, [name]: value}}));
    };

    render() {
        //   let {data, isLoading} = this.props;
        let isLoading = false;
        let data = [];

        return (
            <React.Fragment>
                <Layout>
                    <Grid class="painel" fullWidth>
                        <div className="header-text header-text-report">
                            <h5>{leng.sideBar.intelligentJourney.title}</h5>
                            <h3>{leng.sideBar.intelligentJourney.links[5]}</h3>
                        </div>
                        <div>
                            <CreateFilters data={data} isLoading={isLoading} onChange={(e) => {
                                this.handleChange(e)
                            }}/>
                        </div>
                    </Grid>
                </Layout>
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({schedule}) => schedule;

const mapDispatchToProps = dispatch => ({
    fetchData: () => dispatch(schedule_get_all_filters()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Create);
